<button
    type="button"
    class="button-icon close-button"
    (click)="menuCollapse.emit()"
    [attr.aria-label]="'mainPage.menu.mobileMenuStateAriaLabel' | transloco : { isMenuExpanded: true }"
>
    <dtm-ui-icon name="close"></dtm-ui-icon>
</button>

<ng-template #menuItemTemplate let-label="label" let-icon="icon" let-link="link" let-fragment="fragment">
    <a
        [routerLink]="link"
        routerLinkActive="active-route"
        [fragment]="fragment"
        (click)="menuCollapse.emit()"
        [routerLinkActiveOptions]="linkActiveOptions"
    >
        <dtm-ui-icon *ngIf="icon" [name]="icon"></dtm-ui-icon>
        <span class="label">{{ label }}</span>
    </a>
</ng-template>

<ul class="menu-list">
    <li>
        <ng-template
            [ngTemplateOutlet]="menuItemTemplate"
            [ngTemplateOutletContext]="{
                label: 'dtmMainPageLib.menu.dashboardMenuItemLabel' | transloco,
                link: '/'
            }"
        ></ng-template>
    </li>
</ul>
<ng-container *ngrxLet="isKpoSectionOpen$ as isKpoSectionOpen">
    <button
        type="button"
        class="section-section-expandable"
        (click)="toggleKpoSection()"
        [attr.aria-expanded]="isKpoSectionOpen"
        [attr.aria-label]="'dtmMainPageLib.menu.kpoMenuStateAriaLabel' | transloco : { state: isKpoSectionOpen }"
    >
        <span class="label">{{ "dtmMainPageLib.menu.kpoMenuItemLabel" | transloco }}</span>
        <dtm-ui-icon [name]="isKpoSectionOpen ? 'arrow-up' : 'arrow-down'"></dtm-ui-icon>
    </button>
    <ul class="menu-list submenu-list" *ngIf="isKpoSectionOpen">
        <li *ngFor="let kpoMenuItem of MAIN_PAGE_KPO_PAGES_LIST">
            <ng-template
                [ngTemplateOutlet]="menuItemTemplate"
                [ngTemplateOutletContext]="{
                    label: kpoMenuItem.labelTranslationKey | transloco,
                    link: kpoMenuItem.link
                }"
            ></ng-template>
        </li>
    </ul>
</ng-container>
<ng-container *ngrxLet="isServicesSectionOpen$ as isServicesSectionOpen">
    <button
        type="button"
        class="section-section-expandable"
        (click)="toggleServicesList()"
        [attr.aria-expanded]="isServicesSectionOpen"
        [attr.aria-label]="'dtmMainPageLib.menu.serviceMenuStateAriaLabel' | transloco : { state: isServicesSectionOpen }"
    >
        <span class="label">{{ "dtmMainPageLib.menu.servicesMenuItemLabel" | transloco }}</span>
        <dtm-ui-icon [name]="isServicesSectionOpen ? 'arrow-up' : 'arrow-down'"></dtm-ui-icon>
    </button>
    <ul class="menu-list submenu-list" *ngIf="isServicesSectionOpen">
        <li *ngFor="let servicesMenuItem of MAIN_PAGE_SERVICES_LIST">
            <ng-template
                [ngTemplateOutlet]="menuItemTemplate"
                [ngTemplateOutletContext]="{
                    label: servicesMenuItem.labelTranslationKey | transloco,
                    link: servicesMenuItem.link
                }"
            ></ng-template>
        </li>
    </ul>
</ng-container>
<ul class="menu-list">
    <!--  TODO: REJ-2688 enable after translations ready -->
    <!-- <li>
        <ng-template
            [ngTemplateOutlet]="menuItemTemplate"
            [ngTemplateOutletContext]="{
                label: 'dtmMainPageLib.menu.faqLabel' | transloco,
                link: '/',
                fragment: FAQ_SECTION
            }"
        ></ng-template>
    </li> -->
    <li>
        <ng-template
            [ngTemplateOutlet]="menuItemTemplate"
            [ngTemplateOutletContext]="{
                label: 'dtmMainPageLib.menu.pilotOperatorSearchLabel' | transloco,
                link: '/pilot-operator-search'
            }"
        ></ng-template>
    </li>
    <!-- NOTE: Roadmap temporarily disabled -->
    <!--    <li>
        <ng-template
            [ngTemplateOutlet]="menuItemTemplate"
            [ngTemplateOutletContext]="{
                label: 'dtmMainPageLib.menu.roadmapLabel' | transloco,
                link: '/roadmap'
            }"
        ></ng-template>
    </li>-->
    <li>
        <ng-template
            [ngTemplateOutlet]="menuItemTemplate"
            [ngTemplateOutletContext]="{
                label: 'dtmMainPageLib.menu.systemStateLabel' | transloco,
                link: '/system-state'
            }"
        ></ng-template>
    </li>
</ul>
<ng-container *ngrxLet="isHelpSectionOpen$ as isHelpSectionOpen">
    <button
        type="button"
        class="section-section-expandable"
        (click)="toggleHelpSection()"
        [attr.aria-expanded]="isHelpSectionOpen"
        [attr.aria-label]="'dtmMainPageLib.menu.helpMenuStateAriaLabel' | transloco : { state: isHelpSectionOpen }"
    >
        <span class="label">{{ "dtmMainPageLib.menu.helpMenuItemLabel" | transloco }}</span>
        <dtm-ui-icon [name]="isHelpSectionOpen ? 'arrow-up' : 'arrow-down'"></dtm-ui-icon>
    </button>
    <ul class="menu-list submenu-list" *ngIf="isHelpSectionOpen">
        <li *ngFor="let menuItem of MAIN_PAGE_HELP_PAGES_LIST">
            <a [href]="menuItem.link" target="_blank" (click)="menuCollapse.emit()">
                <dtm-ui-icon [name]="menuItem.iconName"></dtm-ui-icon>
                <span class="label">{{ menuItem.labelTranslationKey | transloco }}</span>
            </a>
        </li>
    </ul>
</ng-container>
<ul class="menu-list">
    <li>
        <dtm-ui-language-select
            [languages]="languages"
            [selectedLanguage]="activeLanguage$ | ngrxPush"
            (languageChange)="activeLanguageSet.emit($event)"
        >
        </dtm-ui-language-select>
    </li>
</ul>
